import { render, staticRenderFns } from "./PropertyAnalyse.vue?vue&type=template&id=5634a2ac&scoped=true"
import script from "./PropertyAnalyse.vue?vue&type=script&lang=js"
export * from "./PropertyAnalyse.vue?vue&type=script&lang=js"
import style0 from "./PropertyAnalyse.vue?vue&type=style&index=0&id=5634a2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634a2ac",
  null
  
)

export default component.exports